// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7f77f7fe","239":"dfdb0d71","455":"f5a0b021"}[chunkId] + ".chunk.js";
};